import * as v from "valibot";

import { rpcContract } from "../rpc";

export const updateCommunitiesOrderRpcContract = rpcContract({
  name: "update-communities-order",
  paramsSchema: v.object({
    communityIds: v.pipe(v.array(v.string()), v.minLength(1), v.maxLength(100)),
  }),
  resultSchema: v.object({
    success: v.boolean(),
  }),
});

export type UpdateCommunitiesOrderParams = v.InferOutput<(typeof updateCommunitiesOrderRpcContract)["paramsSchema"]>;
export type UpdateCommunitiesOrderResult = v.InferOutput<(typeof updateCommunitiesOrderRpcContract)["resultSchema"]>;
